// Injected at build time by webpack.config.js's DefinePlugin. Defaults to
// today's local-dev behavior (backend on the same laptop, port 3002) --
// a hosted build sets API_BASE_URL to the backend's own public hostname
// (e.g. https://api.platform.ncoda.ai), since the browser calling this,
// not the frontend container, is what needs to reach it.
export const API_BASE_URL: string = process.env.API_BASE_URL as string;
